import React from 'react'
import classNames from 'classnames'
import { Box, BoxProps } from '@chakra-ui/react'
import './Message.less'

export enum MessageTypes {
  INFO = 'INFO',
  WARNING = 'WARNING',
  ERROR = 'ERROR',
  SUCCESS = 'SUCCESS',
  NEUTRAL = 'NEUTRAL'
}

type MessageProps = BoxProps & {
  type?: MessageTypes
  children: any
  className?: string
}

// TODO remove and replace all usages with chakra Alert
const Message = ({
  type = MessageTypes.INFO,
  children,
  className,
  ...rest
}: MessageProps) => {
  return (
    <Box
      className={classNames(`Message Message__${type}`, className)}
      {...rest}
    >
      {children}
    </Box>
  )
}

export default Message
